module.exports = __webpack_public_path__ + "img/LOGO_NUBBO_FINAL-02.e40a6f8f.png";